class ProductSwatches extends HTMLElement {
  constructor() {
    super();

    this.swatchTitle = this.parentNode.querySelector(".js-selected-swatch");
    this.swatches = this.querySelectorAll(".colour-swatch");
    this.inputs = this.querySelectorAll("input[type='radio'");
    
    let priceContainer = document.querySelector('.product__review-price .price-item');
    let percentageDiscountContainer = document.querySelector('.product__review-price .price__percentage');
    let comparePriceContainer = document.querySelector('.product__review-price .price-item.price-item--compare');

    if (this.swatchTitle && this.swatches) {
      this.swatches.forEach((swatch) => {
        swatch.addEventListener("mouseover", () => {
          const colourTitle = swatch.getAttribute("data-name");
          this.swatchTitle.innerHTML = colourTitle;
        });

        if (this.inputs) {
          swatch.addEventListener("mouseleave", () => {
            this.inputs.forEach((input) => {
              if (input.checked) {
                this.swatchTitle.innerHTML = input.value;
              }
            });
          });
        }

        document.addEventListener('variant:change', (e) => {
          let currentVariantPrice = (e.detail.price / 100).toFixed(2);
          let currentVariantComparePrice = (e.detail.compare_at_price / 100).toFixed(2);
          let currentVariantPercentage = e.detail.percentage_discount;
        
          currentVariantPrice = parseFloat(currentVariantPrice);
          currentVariantComparePrice = parseFloat(currentVariantComparePrice);
        
          const locale = window.Shopify.currency.active === 'EUR' ? 'fr-FR' : `${window.Shopify.locale}-${window.Shopify.country}`;
          const currency = window.Shopify.currency.active;
        
          let formattedPrice = this.formatPrice(currentVariantPrice, locale, currency);
          let formattedCompareAtPrice = this.formatPrice(currentVariantComparePrice, locale, currency);
        
          if (currency === 'EUR') {
            formattedPrice = this.cleanFormattedPrice(formattedPrice);
            formattedCompareAtPrice = this.cleanFormattedPrice(formattedCompareAtPrice);
          }

          if (currency === 'MYR') {
            formattedPrice = `${this.formatPrice(currentVariantPrice, locale, currency).replace(/\s/g, '')} ${currency}`;
            formattedCompareAtPrice = `${this.formatPrice(currentVariantComparePrice, locale, currency).replace(/\s/g, '')} ${currency}`;
          }

          priceContainer.textContent = formattedPrice;

          if (currentVariantPercentage > 0) {
            comparePriceContainer.textContent = formattedCompareAtPrice;
            percentageDiscountContainer.textContent = `(-${currentVariantPercentage}%)`;
          } else {
            comparePriceContainer.textContent = '';
            percentageDiscountContainer.textContent = '';
          }
        });
      });
    }
  }

  formatPrice(price, locale, currency) {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency,
      currencyDisplay: 'symbol',
      minimumFractionDigits: price % 1 === 0 ? 0 : 2,
      maximumFractionDigits: 2,
    }).format(price);
  }
  
  cleanFormattedPrice(formattedPrice) {
    const formattedPriceVal = formattedPrice;
    const formattedPriceStr = formattedPriceVal.slice(formattedPriceVal.length - 1) + formattedPriceVal.slice(0, formattedPriceVal.length - 1);
    return formattedPriceStr.replace(/\u00A0/g, ' ');
  } 
}

customElements.define("product-swatches", ProductSwatches);
